import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';
import { useTranslation } from 'react-i18next';
import NiceModal from '@ebay/nice-modal-react';

// Import utilities
import useSelectTheme from 'components/utilities/hooks/templates/useSelectTheme';
import useAppResources from './useAppResources';
import useAppTemplate from './useAppTemplate';

// Import components
import { CookieMessage } from 'components/elements';
import { ToggleRPC } from 'components/utilities';
import PortalUnavailable from 'components/views/PortalUnavailable';
import PushNotifications from './PushNotifications';

// Import global styles
import GlobalStyle from 'components/theme/GlobalStyle';

const AppTemplate = ({ children }) => {
	const { i18n } = useTranslation();
	// const [cookieNotice, setCookieNotice] = React.useState(false);
	const isPortalAvailable = useSelector(
		({ portal }) => portal.isPortalAvailable
	);

	useAppResources();

	const { cookieNotice, isAuth } = useAppTemplate();

	// Select theme or get one based on project env
	const selectedTheme = useSelectTheme();

	// Set app current language
	document.documentElement.lang = i18n.language;

	const renderContainerContent = () => (
		<>
			{isAuth && <PushNotifications />}
			{children}
			<ToggleRPC initial={!cookieNotice}>
				{({ on, toggle }) => <>{on && <CookieMessage toggle={toggle} />}</>}
			</ToggleRPC>
		</>
	);

	return (
		<ThemeProvider theme={selectedTheme}>
			<NiceModal.Provider>
				<GlobalStyle />
				{isPortalAvailable ? (
					<Container>{renderContainerContent()}</Container>
				) : (
					<PortalUnavailable />
				)}
			</NiceModal.Provider>
		</ThemeProvider>
	);
};

const Container = styled.div`
	min-height: 100%;
	display: flex;
	flex-direction: column;
	background: ${({ theme: { general } }) => general.body};

	overflow-x: hidden;
`;

AppTemplate.propTypes = {
	children: PropTypes.array.isRequired
};

export default AppTemplate;
